import {
  appAssetsCdnUrl,
  assetsCdnUrl,
  cubeApiUrl
} from '~/constants/environment';

const imageBase = `${appAssetsCdnUrl}/images/dealership/test-drive-center`;

export const testDriveCenterImages = {
  haloJeep: `${imageBase}/halo-jeep-grand-cherokee.png`,
  heroLanes: `${imageBase}/lanes-curve.jpg`,
  howAppCube: `${imageBase}/app-cube.jpg`,
  howDropOff: `${imageBase}/drop-off.jpg`,
  howSpaceMarker: `${imageBase}/space-marker.jpg`,
  storefront: `${imageBase}/storefront.jpg`
};

export const carvanaInverseLogo = `${appAssetsCdnUrl}/svgs/carvana-horizontal-inverse.svg`;

const lotImageBase = `${assetsCdnUrl}/merch-assets/new-car/test-drive-center`;

export const lotMapImage = `${lotImageBase}/lot-map-v3.png`;

export const lotCarsApiUrl = `${cubeApiUrl}/api/lot-cars`;

export function getJellyImageUrl(imgPath: string): string {
  const fileName = imgPath.split('/').pop() ?? '';

  return `${lotImageBase}/jelly/${fileName}`;
}
